import { getMessages } from '../../../../../../../store/constants';

export const CARD_ADD_COLOR_TAGS = getMessages().getText('card_form_add_color_tags');
export const CARD_COLOR_TAGS_ALL = getMessages().getText('card_form_color_tags_all');
export const CARD_COLOR_TAGS_BOARD = getMessages().getText('card_form_color_tags_board');
export const CARD_COLOR_TAGS = getMessages().getText('common.color_tags');
